const targetOrigin = `${window.location.protocol}//${window.location.hostname}${
  window.location.port ? ":" + window.location.port : ""
}`;

export function openTabAndPassData<T>(url: string, data: T) {
  const openedWindow = window.open(url, "_blank");

  function handle_message(event) {
    if (event.data === "orchid_new_tab_ready_for_data") {
      if (!openedWindow) {
        return;
      }
      openedWindow.postMessage(
        {
          msg_type: "orchid_tab_data",
          content: data,
        },
        targetOrigin,
      );
      window.removeEventListener("message", handle_message);
    }
  }

  window.addEventListener("message", handle_message, false);

  // make sure it's removed eventually
  setTimeout(
    () => window.removeEventListener("message", handle_message),
    60000,
  );
}

export async function newTabReceiveData<T = any>(): Promise<T> {
  return new Promise((resolve, reject) => {
    if (!window.opener) reject("No parent page");
    let dataReceived = false;

    function handle_message(event) {
      if (
        event.origin === targetOrigin &&
        event.data.msg_type === "orchid_tab_data"
      ) {
        dataReceived = true;
        window.removeEventListener("message", handle_message);
        resolve(event.data.content as T);
      }
    }

    window.addEventListener("message", handle_message, false);

    window.opener?.postMessage("orchid_new_tab_ready_for_data", targetOrigin);

    // make sure it's removed eventually
    setTimeout(() => {
      if (!dataReceived) {
        reject("failed to receive data");
        window.removeEventListener("message", handle_message);
      }
    }, 60000);
  });
}
